/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa data layer
 *
 */
Intesa.DataLayer = function() {

	/**
	 * Local variables
	 *
	 */
	var data_layer = this;
	var latestLoanItem = false;
	var dataJSON = "";

	/**
	 * Init component
	 *
	 */
	this.init = function() {

		// check if dataLayer exist
		window.dataLayer = window.dataLayer || [];

		// sobstitute product name
		data_layer.replaceProductName();

		// attach events handlers
		data_layer.attachPushDataClickEvent();
		data_layer.attachPushDataClickEventCallEmailFooter();
		data_layer.attachPushDataClickEventLoan();
		data_layer.attachPushDataClickEventFormBIB();
		data_layer.attachPushDataWithRedirectClickEvent();
		data_layer.attachPushDataChatClickEvent();
		data_layer.attachUpdateLoanOptionsPushDataClickEvent();
		data_layer.attachRemoveLoanClickEvent();
		data_layer.attachCom08EmailClickEvent();

	};


	/**
	 * Attach Com08 Email Click Event
	 *
	 */
	this.attachCom08EmailClickEvent = function() {

		var component = $( '[data-component="FakeTab"] + .tab-content [data-component="Com08"]' );

		// if component exists
		if( component.length ) {

			$( component ).on( 'click', 'a', function() {

				// get link
				var link = $( this ).attr( 'href' );
				link = link.split( ':' );

				// get email
				var isEmail = link[0] === 'mailto';
				var emailAddress = link[1] ? link[1] : undefined;

				// push if it's an email
				if( isEmail && emailAddress !== undefined ) {
					
					if($("html").attr("data-bank") == "VUB" || $("html").attr("data-bank") == "ISPBIH"){
 						window.dataLayer.push({
 							'event': 'service',
 							'eventCategory': 'email',
 							'eventAction': 'submit',
 							'eventLabel' : emailAddress
 						});
					}else{
						window.dataLayer.push({
							'event': 'service',
							'serviceCat': 'email',
							'serviceAction': 'submit',
							'serviceLabel' : emailAddress
						});
					}
					
				}

			} );

		}

	};


	/**
	 * Attach Remove Loan Click Event
	 *
	 */
	this.attachRemoveLoanClickEvent = function() {

		$( document ).on( 'click', '.cart__summary__item--salary .cart__summary__item__remove', function() {

			data_layer.updateLoanOptionsEvtAction();

		} );

	};


	/**
	 * Remove Last Active Option
	 *
	 */
	this.attachUpdateLoanOptionsPushDataClickEvent = function() {

		$( document ).on( 'click', '.-js-loansItem__link', function() {

			// if there's a previous option selected, remove it
			data_layer.removeLastActiveOption( $(this) );

			// update evtAction property for every option
			data_layer.updateLoanOptionsEvtAction();

		} );

	};


	/**
	 * Remove Last Active Option
	 *
	 */
	this.removeLastActiveOption = function( $this ) {

		var thereIsALastItem = latestLoanItem !== false;
		var thisIsNotLastItem = $this.attr( 'data-salary-code' ) !== latestLoanItem;

		// push remove of the previus added item
		if( thereIsALastItem && thisIsNotLastItem ) {

			// get data from attribute
			var data = $( '[data-salary-code="' + latestLoanItem + '"]' ).attr( 'data-layer-push' );
			data = JSON.parse( data );

			// push data
			window.dataLayer.push( data );

		}

	};


	/**
	 * Update Loan Options EvtAction
	 *
	 */
	this.updateLoanOptionsEvtAction = function() {

		var options = $( '.-js-loansItem__link' ).not( '.-js-no-click' );
		var thereIsAnActiveOption = false;

		options.each( function() {

			var $this = $( this );
			var isOptionActive = $this.hasClass('itemActive');

			// get datalayer push data
			var data = $this.attr( 'data-layer-push' );
			data = JSON.parse(data);

			// update evtAction property
			if( isOptionActive ) {

				thereIsAnActiveOption = true;
				data.evtAction = 'removed from cart';
				latestLoanItem = $this.attr( 'data-salary-code' );

			} else {

				data.evtAction = 'added to cart';

			}

			// update attribute data
			data = JSON.stringify(data);
			$this.attr( 'data-layer-push', data );

		} );

		// reset latestLoanItem to false if there's not an active option
		if( !thereIsAnActiveOption ) latestLoanItem = false;

	};


	/**
	 * Replace Product Name
	 *
	 */
	this.replaceProductName = function() {

		var component = $( '*[data-replace-name]' );

		if ( component.length ) {

			// get push data from attribute and replace productName
			var data = component.attr( 'data-layer-push' );
			data = data.replace( '<productName>', '"' + window.globalProductName + '"' );

			// insert new data
			component.attr( 'data-layer-push', data );

		}

	};


	/**
	 * Attach Push Data Click Event
	 *
	 */
	this.attachPushDataClickEvent = function() {

		$( document ).on( 'click', '*[data-layer-push]', function() {

			// get data from attribute
			var data = $( this ).attr( 'data-layer-push' );
			data = JSON.parse( data );

			// push data
			window.dataLayer.push( data );

		} );

	};


	/**
	 * Attach Push Data Click Event Loan
	 *
	 */
	this.attachPushDataClickEventLoan = function() {

		$( document ).on( 'click', '*[data-layer-loan-calculator]', function() {
			var $calculator  = $(this).parents('[data-calculator]');

			if($calculator.length !== 1) return;

			var isBIB = $('html').attr('data-bank') == 'BIB';
			var isISPBIH = $('html').attr('data-bank') == 'ISPBIH';
			var data;
			if(isISPBIH){
				data = '{"event": "calculator","eventCategory": "loan","eventAction": "[PLAN]","eventLabel": "submit","eventName": "loan calculator","loan_amount": "[AMOUNT]","currency_code": "[CURRENCY]","interest_type": "[TYPE]","loan_duration": "[DURATION]","with_mortgage": "[MORTGAGE]","salary_transfer": "[YES|NO]","monthly_installment": "[INSTALLMENT]","amount_to_repay": "[REPAY]","tenor": "[TENOR]","interest_rate": "[RATE]","aprc": "[APRC]","approval_cost": "[COST]","fee": "[FEE]"}';
			} else {
				data = '{"event": "loan_calculator","eventCategory": "loan calculator","eventAction": "[PLAN]","eventLabel": "submit","eventName": "submit","loan_amount": "[AMOUNT]","currency_code": "[CURRENCY]","interest_type": "[TYPE]","loan_duration": "[DURATION]","with_mortgage": "[MORTGAGE]","salary_transfer": "[YES|NO]","monthly_installment": "[INSTALLMENT]","amount_to_repay": "[REPAY]","tenor": "[TENOR]","interest_rate": "[RATE]","aprc": "[APRC]","approval_cost": "[COST]","fee": "[FEE]"}';
			}
			var amount = $calculator.find(".open strong[data-layer-loan-amount]").text();
			if(isBIB || isISPBIH){
				amount = amount.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
			} else {
				amount = amount.replace(/\s/g, '').replace(',', '.');	
			}
			amount = parseFloat(amount);

			var interestType = $calculator.find("select[name='interestRateType']").val();//$(".open strong[data-layer-loan-type]").text();			

			var duration = ($calculator.find("input[class='rangeslider rangeslider--2']").val() != null && $calculator.find("input[class='rangeslider rangeslider--2']").val() != 'undefined')?$calculator.find("input[class='rangeslider rangeslider--2']").val():$calculator.find("input[name='repaymentOptionsValue']").val();//$(".open strong[data-layer-loan-duration]").text();
			var salaryTrasfer = ($calculator.find(".open").length>0 && $calculator.find(".open").get(0).hasAttribute('data-layer-loan-salary-transfer'))?"YES":"NO";
			var tenor = $calculator.find("input[class='rangeslider rangeslider--2']").val();			
			if(isBIB || isISPBIH){
				var months = $calculator.find("input[class='rangeslider rangeslider--2']").val();
				if($calculator.find(".open strong[data-layer-loan-tenor]").length > 0){
					months = $calculator.find(".open strong[data-layer-loan-tenor]").text();
				}
				tenor = months;
				duration = months;

			}
			var repay = "";
			if($calculator.find(".open strong[data-layer-loan-repay]").length>1){				
				var element = $calculator.find(".open strong[data-layer-loan-repay]");
				repay = "";
				for (index = 0; index < element.length; ++index) {
					repay = repay + element[index].innerText + "|-|";
				}				
			}else{
				repay = $calculator.find(".open strong[data-layer-loan-repay]").text();
				if(isBIB){
					repay = repay.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
				} else {
					repay = repay.replace(/\s/g, '').replace(',', '.');				
				}	
				repay = parseFloat(repay);
			}
			
			var installment = "";
			if($calculator.find(".open strong[data-layer-loan-installment]").length>1){				
				var element = $calculator.find(".open strong[data-layer-loan-installment]");
				installment = "";
				for (index = 0; index < element.length; ++index) {
					var singleInstallment = element[index].innerText;

					if(isBIB || isISPBIH) singleInstallment = singleInstallment.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');

					installment = installment + singleInstallment + "|-|";
				}				
			}else{
				installment = $calculator.find(".open strong[data-layer-loan-installment]").text();
				if(isBIB || isISPBIH){
					installment = installment.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
				} else {
					installment = installment.replace(/\s/g, '').replace(',', '.');		
				}
				installment = parseFloat(installment);
			}
						
			var rate = "";
			if($calculator.find(".open strong[data-layer-loan-rate]").length>1){				
				var element = $calculator.find(".open strong[data-layer-loan-rate]");
				rate = "";
				for (index = 0; index < element.length; ++index) {
					rate = rate + element[index].innerText + "|-|";
				}				
			}else{
				rate = $calculator.find(".open strong[data-layer-loan-rate]").text();
				if(isBIB || isISPBIH){
					rate = rate.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
				} else {
					rate = rate.replace(/\s/g, '').replace(',', '.');
				}
				rate = parseFloat(rate);
			}
						
			var aprc = "";
			if($calculator.find(".open strong[data-layer-loan-aprc]").length>1){				
				var element = $calculator.find(".open strong[data-layer-loan-aprc]");
				for (index = 0; index < element.length; ++index) {
					aprc = aprc + element[index].innerText + "|-|";
				}				
			}else{
				aprc = $calculator.find(".open strong[data-layer-loan-aprc]").text();
				if(isBIB || isISPBIH){
					aprc = aprc.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
				} else {
					aprc = aprc.replace(/\s/g, '').replace(',', '.');
				}
				aprc = parseFloat(aprc);
			}
	
			var cost = $calculator.find(".open strong[data-layer-loan-cost]").text();
			if(isBIB || isISPBIH){
				cost = cost.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
			} else {
				cost = cost.replace(/\s/g, '').replace(',', '.');
			}
			cost = parseFloat(cost);
			var fee = $calculator.find(".open strong[data-layer-loan-fee]").text();
			if(isBIB || isISPBIH){
				fee = fee.replace(',', '[P]').replaceAll(".", "").replace("[P]", ".").replace(/\s/g, '');
			} else {
				fee = fee.replace(/\s/g, '').replace(',', '.');
			}
			fee = parseFloat(fee);
			var mortgage = ($calculator.find(".open").length>0 && $calculator.find(".open").get(0).hasAttribute('data-layer-mortgage'))?"YES":"NO";			
			var currency = ($calculator.find(".open").length>0 && $calculator.find(".open").get(0).hasAttribute('data-layer-loan-currency'))?$calculator.find(".open").get(0).getAttribute('data-layer-loan-currency'):"";

			if(amount != null && amount != 'undefined'){}
				data = data.replace("[AMOUNT]", amount);

			if(interestType != null && interestType != 'undefined')
				data = data.replace("[TYPE]", interestType);

			if(duration != null && duration != 'undefined')
				data = data.replace("[DURATION]", duration);
			
			if(salaryTrasfer != null && salaryTrasfer != 'undefined')
				data = data.replace("[YES|NO]", salaryTrasfer);
			
			if(installment != null && installment != 'undefined')
				data = data.replace("[INSTALLMENT]", installment);

			if(repay != null && repay != 'undefined')
				data = data.replace("[REPAY]", repay);

			if(tenor != null && tenor != 'undefined')
				data = data.replace("[TENOR]", tenor);

			if(rate != null && rate != 'undefined')
				data = data.replace("[RATE]", rate);

			if(aprc != null && aprc != 'undefined')
				data = data.replace("[APRC]", aprc);

			if(cost != null && cost != 'undefined')
				data = data.replace("[COST]", cost);

			if(fee != null && fee != 'undefined')
				data = data.replace("[FEE]", fee);

			if(mortgage != null && mortgage != 'undefined')
				data = data.replace("[MORTGAGE]", mortgage);
			
			if(currency != null && currency != 'undefined')
				data = data.replace("[CURRENCY]", currency);
			
			/*[PLAN]at eventAction will be filled with the plan type selected by the user e.g. 'House',
			'Housefor young', 'Non-purpose loan', 'Education', 'Non-purpose mortgage' or 'Retirement'*/
			//var plan = $calculator.find(".open strong[data-layer-loan-plan]").text();		
			var plan = $calculator.find("input[name='typeloan']").val();
			if(plan != null && plan != 'undefined')
				data = data.replace("[PLAN]", plan);

			var data = JSON.parse( data );
			
			//Change String Number to Float
			data.monthly_installment = parseFloat(data.monthly_installment);
			data.amount_to_repay= parseFloat(data.amount_to_repay);
			data.tenor = parseFloat(data.tenor);
			data.loan_duration = parseFloat(data.loan_duration);
			data.interest_rate = parseFloat(data.interest_rate);
			data.aprc = parseFloat(data.aprc);
			if(isBIB){
				data.approval_cost = 0;
			}
			if(isISPBIH){
				data.approval_cost = 0;
				data.aprc = 0;
			}
			data.approval_cost = parseFloat(data.approval_cost);
			data.fee = parseFloat(data.fee);
			// push data
			window.dataLayer.push( data );
		});

	}

	/**
	 * Attach Push Data Click Event for Footer Email and Call and callMe
	 *
	 */
	this.attachPushDataClickEventCallEmailFooter = function() {

		$( document ).on( 'click', '*[data-layer-floating-call]', function() {

			var data='{"event": "call_me_back","eventCategory": "contact us","eventAction": "call me back","eventLabel": "[BRANCH]","eventName": "call me back","call_back_time": "[TIME]"}';
			var branch = ($("input[name='branch']").length>0)?$("input[name='branch']").get($("input[name='branch']").length - 1).value:"";
			if(branch != null && branch != 'undefined')
				data = data.replace("[BRANCH]", branch);

			var time = ($("select[name='selectTime']").length>0)?$("select[name='selectTime']").val():"";
			if(time != null && time != 'undefined')
				data = data.replace("[TIME]", time);
			if(time != null && time != 'undefined' && branch != null && branch != 'undefined'){
				var data = JSON.parse( data );
				// push data
				window.dataLayer.push( data );
			}
		});

		$( document ).on( 'click', '*[data-layer-calls]', function() {

			var data='{"event": "contact_link","eventCategory": "contact_link","eventAction": "phone number","eventLabel": "[POSITION]","eventName": "contact_link","service":"[SERVICE]"}';

			var path = $(this).attr('data-path-footer');
			if(path != null && path != 'undefined')
				data = data.replace("[POSITION]", path);

			var service = $(this).attr('data-footer-menu_title');
			if(service != null && service != 'undefined')
				data = data.replace("[SERVICE]", service);

			var data = JSON.parse( data );

			// push data
			window.dataLayer.push( data );
		});

		$( document ).on( 'click', '*[data-layer-email]', function() {

			var data='{"event": "contact_link","eventCategory": "contact_link","eventAction": "email","eventLabel": "[POSITION]","eventName": "contact_link"}';

			var path = $(this).attr('data-path-footer');
			if(path != null && path != 'undefined')
				data = data.replace("[POSITION]", path);

			var data = JSON.parse( data );

			// push data
			window.dataLayer.push( data );
		});

	}

	/**
	 * Attach Push Data Click Event BIB
	 *
	 */
	this.attachPushDataClickEventFormBIB = function() {

		$( document ).on( 'click', '*[data-layer-bib-push]', function() {
			//var data = $("div[data-layer-bib-push]"); CALL ME

			var data = '';
			
			var formType = $("input[name='formType']").val();

			if(formType != null && formType != 'undefined'){
				
				if(formType === 'CONTACTUS'){

					data='{"event": "service","eventCategory": "contactus","eventAction": "submit","eventLabel": "[TOPIC]","eventName": "contact us"}';

					var topic = $("input[name='topicOption']").val();
					if(topic != null && topic != 'undefined')
						data = data.replace("[TOPIC]", topic);

				}else if(formType === 'LEAVEAMESSAGE'){
					data ='{"event": "service","eventCategory": "message","eventAction": "sumbit","eventName": "leave a message", "eventLabel": ""}';

				}else if(formType === 'ANONYMCALLME'){
					data ='{"event": "service","eventCategory": "call me back","eventAction": "submit","eventLabel": "[BRANCH]","call_back_time": "[MORNING|AFTERNOON]"}';
					if(branch != null && branch != 'undefined')
						data = data.replace("[BRANCH]", branch);
					if($("select[name='selectTime']").length>0){
						var time = $("select[name='selectTime']").val();
						data = data.replace("[MORNING|AFTERNOON]", time);
					}
				}else if(formType === 'ANONYMCALLMETOBOOKAPP'){
					
					if ($("html").attr("data-bank") != "VUB"){
						
						data ='{"event": "service","eventCategory": "appointments","eventAction": "submit","eventLabel": "[BRANCH]","eventName": "book an appointment","time_preference": "[MORNING|AFTERNOON]","service": "[SERVICE]"}';

						var branch = $("input[name='branch']").val();
						if(branch != null && branch != 'undefined')
							data = data.replace("[BRANCH]", branch);

						if($("input[name='radio']:checked").length>0){
							var time = $("input[name='radio']:checked").get(0).value;
							data = data.replace("[MORNING|AFTERNOON]", time);
						}

						var service = $("input[name='topicOption']").val();
						
						if(service != null && service != 'undefined')
							data = data.replace("[SERVICE]", service);
						
					}else{
						
						data ='{"event": "service","eventCategory": "appointments","eventAction": "submit","eventName": "book an appointment","branchname": "[BRANCH]"}';
						
						var branch = $("input[name='branch']").val();
						if(branch != null && branch != 'undefined')
							data = data.replace("[BRANCH]", branch);
						
						
					}
					
				}else if(formType === 'COMPLAINTS_TICKETING_INDIVIDUAL'){
					data='{"event": "service","eventCategory": "complaints","eventAction": "individuals complaint","eventLabel": "[SERVICE]","eventName": "individuals complaint","request_type": "[COMPLAIN|REQUEST]","complaint_details": "[DETAILS]"}';

					var reason = $("input[name='reasonOfRequest']").val();

					reason = reason.split("|");

					var service = (reason.length>2) ?reason[1]: '';//$("input[name='reasonId']").val();					
					if(service != null && service != 'undefined')
						data = data.replace("[SERVICE]", service);

					var complain_request = (reason.length>2) ?reason[2]: '';//$("input[name='subReasonId']").val();
					if(complain_request != null && complain_request != 'undefined')
						data = data.replace("[COMPLAIN|REQUEST]", complain_request);

					var details = ($(".dz-details").length>0)?"YES":"NO";
					if(details != null && details != 'undefined')
						data = data.replace("[DETAILS]", details);

				}else if(formType === 'COMPLAINTS_TICKETING_LEGAL_ENTITY'){
					data='{"event": "service","eventCategory": "complaints","eventAction": "legal entities complaint","eventLabel": "[SERVICE]","eventName": "legal entities complaint","request_type": "[COMPLAIN|REQUEST]","complaint_details": "[DETAILS]"}';

					var reason = $("input[name='reasonOfRequest']").val();

					reason = reason.split("|");

					var service = (reason.length>2) ?reason[1]: '';//$("input[name='reasonId']").val();					
					if(service != null && service != 'undefined')
						data = data.replace("[SERVICE]", service);
					//(reason.length>2) ?reason[2]: '';//$("input[name='subReasonId']").val();
					
					var request_type = ($('.for__tabItem.j-for__tabItem.ticketing.activeWhite').length>0)?$('.for__tabItem.j-for__tabItem.ticketing.activeWhite')[0].getAttribute('data-tab-value'):"";
					var complain_request = null;
					if(request_type != null && request_type != 'undefined'){
						request_type = request_type.split("|");
						complain_request = (request_type.length>0) ?request_type[0]: '';
					}
					if(complain_request != null && complain_request != 'undefined')
						data = data.replace("[COMPLAIN|REQUEST]", complain_request);

					var details = ($(".dz-details").length>0)?"YES":"NO";
					if(details != null && details != 'undefined')
						data = data.replace("[DETAILS]", details);
				}else if(formType === 'COMPLAINTS_PLATFORM'){
					data ='{"event": "track_request","eventCategory": "contact us","eventAction": "track_request","eventLabel": "[OUTCOME]","eventName": "track_request"}';

					var outcome = "Request accepted";					
					if(outcome != null && outcome != 'undefined')
						data = data.replace("[OUTCOME]", outcome);
				}

			}

			sessionStorage.setItem("jsonFormSubmit", data);

		});

		$( document ).ready(function() {
			// get data from attribute

			var data = sessionStorage.getItem("jsonFormSubmit");
			sessionStorage.setItem("jsonFormSubmit", "")

			if($("div[data-success-data-layer]").length>0){

				var formType = $("input[name='formType']").val();

				var data = JSON.parse( data );

				// push data
				window.dataLayer.push( data );
			}
		} );

	};


	/**
	 * Attach Push Data With Redirect Click Event
	 *
	 */
	this.attachPushDataWithRedirectClickEvent = function() {

		$( document ).on( 'click', '*[data-layer-push-redirect]', function(e) {

			// stop link
			e.preventDefault();

			// get data from attribute
			var data = $( this ).attr( 'data-layer-push-redirect' );
			data = JSON.parse( data );

			// push data
			window.dataLayer.push( data );

			// redirect
			window.location = $(this).attr('href');

		} );

	};


	/**
	 * Attach Push Data Chat Click Event
	 *
	 */
	this.attachPushDataChatClickEvent = function() {
		if($("html").attr("data-bank") == "VUB" || $("#startChatBtn").length <= 0) return;
		
		var formType = $("input[name='formType']").val();
		var eventCategory = "chat";

		document.getElementById("startChatBtn").addEventListener("click", function(){
			if($("html").attr("data-bank") == "ISPBIH"){
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'service',
					'eventCategory': 'chat',
					'eventName': 'chat',
				    'eventAction': 'submit',
					'eventLabel' : window.dataLayer[0].pageName
				});
			} else if($("html").attr("data-bank") != "VUB"){
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'service',
				    'serviceCat': 'chat',
				    'serviceAction': 'chat',
					'serviceLabel' : window.dataLayer[0].pageName
				});
			}
			
		});

		$(document).on("click","#cmb__form button", function(){
			setTimeout(function(){
				if(formType != null && formType != 'undefined'){
					
					if(formType === 'CONTACTUS'){
						eventCategory = "contactus";
					}else if(formType === 'LEAVEAMESSAGE'){
						eventCategory = "message";
					}else if(formType === 'ANONYMCALLME'){
						eventCategory = "call me back";
					}else if(formType === 'ANONYMCALLMETOBOOKAPP'){
						eventCategory = "appointments";
					} else {
						eventCategory = "chat";
					}
				}
				
				if ($("#cmb__form").find(".filled").length<=0 && $("html").attr("data-bank") != "CIB"){ 
					
					if($("html").attr("data-bank") == "VUB"){
						window.dataLayer.push({
							'event': 'service',
							'eventCategory': 'chat',
							'eventAction': 'submit'
						});
					} else {
	 					window.dataLayer.push({
	 						'event': 'service',
							'serviceCat': eventCategory,
							'serviceAction': 'submit',
							'serviceLabel' : window.dataLayer[0].pageName
	 					});
					}
				
				}
			}, 500);
		});
		
		$(document).on("click","#cmb__form__retail button", function(){
			setTimeout(function(){
				if(formType != null && formType != 'undefined'){
					
					if(formType === 'CONTACTUS'){
						eventCategory = "contactus";
					}else if(formType === 'LEAVEAMESSAGE'){
						eventCategory = "message";
					}else if(formType === 'ANONYMCALLME'){
						eventCategory = "call me back";
					}else if(formType === 'ANONYMCALLMETOBOOKAPP'){
						eventCategory = "appointments";
					} else {
						eventCategory = "chat";
					}
				}
				if ($("#cmb__form__retail").find(".filled").length<=0){ 		      
					if($("html").attr("data-bank") == "VUB"){
						window.dataLayer.push({
							'event': 'service',
							'eventCategory': 'chat',
							'eventAction': 'submit'
						});
					} else {
	 					window.dataLayer.push({
	 						'event': 'service',
							'serviceCat': eventCategory,
							'serviceAction': 'submit',
							'serviceLabel' : window.dataLayer[0].pageName
	 					});
					}
				}
			}, 500);
		});
		
		$(document).on("click","#cmb__form__business button", function(){
			setTimeout(function(){
				if(formType != null && formType != 'undefined'){
					
					if(formType === 'CONTACTUS'){
						eventCategory = "contactus";
					}else if(formType === 'LEAVEAMESSAGE'){
						eventCategory = "message";
					}else if(formType === 'ANONYMCALLME'){
						eventCategory = "call me back";
					}else if(formType === 'ANONYMCALLMETOBOOKAPP'){
						eventCategory = "appointments";
					} else {
						eventCategory = "chat";
					}
				}
				if ($("#cmb__form__business").find(".filled").length<=0){ 		
					if($("html").attr("data-bank") == "VUB"){
						window.dataLayer.push({
							'event': 'service',
							'eventCategory': 'chat',
							'eventAction': 'submit',
							"eventLabel": window.dataLayer[0].pageName
						});
					} else {
	 					window.dataLayer.push({
							'event': 'service',
							'serviceCat': eventCategory,
							'serviceAction': 'submit',
							'serviceLabel' : window.dataLayer[0].pageName
	 					});
					}
				}
			}, 500);
		});
	};


};

/**
 * Get class instance
 *
 */
Intesa.DataLayer.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

	}
	if( !window.intesa.data_layer ) {

		window.intesa.data_layer = new Intesa.DataLayer();

	}

	return window.intesa.data_layer;

};